// plugins/camelcase-to-dashcase.ts
import "./index.js";
var CamelCaseDashCasePlugin = class {
  matchModifier(path) {
    return true;
  }
  generateFlattenedStyle(pathStyle, flattenedStyle) {
    Object.keys(pathStyle.style ?? {}).forEach((cssprop) => {
      pathStyle.style[cssprop.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()] = pathStyle.style[cssprop];
    });
    return false;
  }
  generateStyleSheetRule(_, styles, sheet) {
    return false;
  }
};
export {
  CamelCaseDashCasePlugin
};
